<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<frodo-page-shell [showConnectionIndicator]="showHeader" [goBack]="showHeader ? goBack : undefined">
  <p *ngIf="showHeader" shell-header>{{ header }}</p>
  <div class="confirmation_prompt">
    <div class="confirmation_prompt__heading">
      {{ title }}
    </div>
    <div class="confirmation_prompt__buttons">
      <button
        class="confirmation_prompt__buttons__cancel"
        [disabled]="isLoading"
        (click)="cancel.emit()"
      >
        {{ cancelLabel }}
      </button>

      <button
        class="confirmation_prompt__buttons__confirm"
        [disabled]="isLoading"
        (click)="confirm.emit()"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</frodo-page-shell>
